// extracted by mini-css-extract-plugin
export default {"modal":"store_modal__rYwyC","carousel":"store_carousel__-eYVs","brands":"store_brands__Q2wIA","grid":"store_grid__81Nau"};